"use client";

import { PanelLeftIcon } from "lucide-react";
import type * as React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../../components/ui/button";
import { useAppShell } from "./app-shell-context";

/**
 * The shell's toggle affordance: opens/closes the mobile nav drawer (and the
 * desktop pane, though the module-menu header owns that on desktop). Ghost icon
 * button, mirroring the base sidebar trigger.
 */
export function AppShellTrigger({
  className,
  onClick,
  ...props
}: React.ComponentProps<typeof Button>): React.ReactElement {
  const { toggleSidebar } = useAppShell();

  return (
    <Button
      aria-label="Toggle navigation"
      className={cn("size-7", className)}
      data-slot="app-shell-trigger"
      onClick={(event) => {
        onClick?.(event);
        toggleSidebar();
      }}
      size="icon"
      variant="ghost"
      {...props}
    >
      <PanelLeftIcon />
    </Button>
  );
}
